import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

const PokemonImage = ({ pokemon, showShiny }) => {
  const shinyAvailable = showShiny && pokemon.sprite_path_shiny?.trim();
  const desiredSrc = shinyAvailable ? pokemon.sprite_path_shiny : pokemon.sprite_path;

  const [src, setSrc] = useState(desiredSrc);
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setLoaded(false);
    setErrored(false);
    setSrc(desiredSrc);
  }, [desiredSrc]);

  const handleError = () => {
    if (!errored) {
      setErrored(true);
      setSrc('/images/placeholder.png');
    }
  };

  return (
    <Box
      component="img"
      src={src}
      alt={pokemon.name}
      title={pokemon.name}
      loading="lazy"
      decoding="async"
      width={64}
      height={64}
      sx={{
        my: 1,
        opacity: loaded ? 1 : 0,
        transition: 'opacity 0.4s ease-in-out',
        display: 'block',
        margin: '0 auto'
      }}
      onLoad={() => setLoaded(true)}
      onError={handleError}
    />
  );
};

export default PokemonImage;
